export const createServiceWorker = (): void => {
  const { serviceWorker } = navigator;
  if (serviceWorker) {
    // void serviceWorker.register(`/serviceWorker.js?apiUrl=${config.apiUrl}`);
    void serviceWorker;
  }
};
